

export function httpGet(url, params, handle, authService) {
    if (authService == null) {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Pragma: 'no-cache',
            }
        };

        params = { ...params };
        url = url + "?" + (new URLSearchParams(params)).toString();
        fetch(url, requestOptions)
            .then(response => {
                return response.json();
            }).then(response => {
                if (handle != null) {
                    handle(response);
                }
            });
    } else {

        const sss = authService.getAccessToken().then(token => {

            const requestOptions = {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Pragma: 'no-cache',
                }
            };

            params = { ...params };
            url = url + "?" + (new URLSearchParams(params)).toString();
            fetch(url, requestOptions)
                .then(response => {
                    return response.json();
                }).then(response => {
                    if (handle != null) {
                        handle(response);
                    }
                });
        });
    }
}

export async function httpGetAwait(url, params) {

    params = { ...params, session: window.getSession() };
    url = url + "?" + (new URLSearchParams(params)).toString();
    const response = await fetch(url);
    const data = await response.json();
    return data;
}

export function httpPost(url, params, handle, authService) {
    if (authService == null) {
       

            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Pragma: 'no-cache',
                },
                body: params.body
            };

        fetch(url, requestOptions)
            .then(response => {
                return response.json();
            })
            .then(response => {
                if (handle != null) {
                    handle(response);
                }
            });
    } else {
        const sss = authService.getAccessToken().then(token => {

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Pragma: 'no-cache',
                },
                body: params.body
            };

            fetch(url, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    if (handle != null) {
                        handle(response);
                    }
                });
        });
    }
}


export function httpFileDownload(url, params, handle, authService) {
    const sss = authService.getAccessToken().then(token => {

        const requestOptions = {
            method: 'GET',
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

       
        const urlGet = url + "?" + (new URLSearchParams(params)).toString();
        fetch(urlGet, requestOptions)
            .then(response => {
                return response.json();
            }).then(ret => {
              

                if (ret.success) {

                    fetch('data:' + ret.tip + ';base64,' + ret.datoteka)
                        .then(fileRes => { return fileRes.blob() })
                        .then(fil => {

                            const file = new Blob([fil]);
                            const fileURL = URL.createObjectURL(file, { type: ret.tip });

                            var anchor = document.createElement("a");
                            anchor.download = ret.naziv;
                            anchor.href = fileURL;
                            anchor.click();
                        })

                    if (handle != null) {
                        handle(ret);
                    }
                }
                else {
                    alert(ret.message);
                }

                
            });
    });


}